export const USER_DETAIL = 'User Details'
export const CREATED = 'Created At'
export const REF_ID = 'Reference ID'
export const STATUS = 'Status'
export const APPLY_FILTER = 'Apply Filter'
export const CLEAR = 'Clear All'
export const NO_RESULT = 'NO RESULT FOUND'
export const LOAD_MORE = 'Load More'
